import React, { useCallback } from 'react';
import type { FC } from 'react';
import { TextInput } from '@wix/cli-ui-kit';
import { useWixCliAppBi } from '../../../bi-app/index.js';

interface ReleaseCommentProps {
  onEntered: (comment: string) => void;
}

export const ReleaseComment: FC<ReleaseCommentProps> = (props) => {
  const { onEntered } = props;

  const bi = useWixCliAppBi();

  const validate = useCallback((value: string) => {
    if (value && value.length > 250) {
      return 'The comment is limited to a maximum of 250 characters';
    }
    return true;
  }, []);

  const question =
    "Enter a comment describing any changes made to this version. This won't be shown to users (optional)";

  return (
    <TextInput
      label={question}
      onSubmit={(answer) => {
        bi.cliFlowStepAnswered({
          question,
          questionKey: 'release_command.enter_release_comment',
          answer,
        });
        onEntered(answer);
      }}
      validate={validate}
    />
  );
};
